
import BaseSliderIndicator from '@/components/BaseSliderIndicator.vue';

export default {
  name: 'HistoryComponentEntry',

  components: {
    BaseSliderIndicator,
  },
  props: {
    year: {
      type: String,
    },
    entry: {
      type: [Object, Array],
    },
  },
  data() {
    return {
      selectedEntryIndex: 0,
      sliderIndicators: 0,
    };
  },
  mounted() {
    this.$refs.entryContainer.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.calcSliderIndicatorItems);
    this.calcSliderIndicatorItems();
  },
  beforeUpdate() {
    this.calcSliderIndicatorItems();
  },
  beforeDestroy() {
    this.$refs.entryContainer.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.calcSliderIndicatorItems);
  },
  methods: {
    changeEntry(index) {
      if (index < 0)  {
        return;
      } else if (index >= this.entry.length) {
        return;
      }

      const entryContainer = this.$refs.entryContainer;

      const scrollWidth = entryContainer.scrollWidth;
      const entryWidth = scrollWidth / this.entry.length;

      entryContainer.scrollTo({ left: index * entryWidth, behavior: 'smooth'});
    },
    onScroll() {

      const entryContainer = this.$refs.entryContainer;

      const scrollLeft = entryContainer.scrollLeft;
      const scrollWidth = entryContainer.scrollWidth;

      const entryWidth = scrollWidth / this.entry.length;
      const scrollIndex = Math.round(scrollLeft / entryWidth);

      if (scrollIndex === this.selectedEntryIndex) {
        return;
      }

      this.selectedEntryIndex = scrollIndex;

    },
    calcSliderIndicatorItems() {
      let sliderIndicator = this.entry.length;

      if (this.$refs.entryContainer.getBoundingClientRect().width >= 768) {
        sliderIndicator = Math.ceil(sliderIndicator / 3);
      }

      this.sliderIndicators = sliderIndicator;
    },
  },
};
